export const darkTheme = {
  palette: {
    primary: {
      main: '#90caf9',
    },
    type: 'dark', // Switching the dark mode on is a single property value change.
  },
};

export const lightTheme = {
  palette: {
    secondary: {
      light: '#77c982',
      main: '#085176',
      dark: '#77c982',
      contrastText: '#fff',
    },
  },
  overrides: {
    MuiFilledInput: {
      root: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        '&$disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      },
    },
  },
  sidebar: {
    width: 200, // The default value is 240
  },
};
